import { currentSuggestion, isLoading, error } from './state'
import { loadSuggestion } from './methods/load-suggestion'
import { formatSuggestion } from './methods/format-suggestion'

/**
 * Öneri görüntüleme işlemlerini yönetmek için composable
 * @returns {Object} Öneri görüntüleme state ve metodları
 */
export const useSuggestionView = () => {
  /**
   * Görüntüleme için state ve metodları döndür
   */
  return {
    // State
    currentSuggestion,
    isLoading,
    error,
    
    // Methods
    loadSuggestion,
    formatSuggestion
  }
}
